"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuHeader = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokens = require("@smartsheet/design-tokens");
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../../theme/utils/useTheme");
var _menuTheme = require("../styled/menuTheme");
const MenuHeaderStyled = (0, _styled.default)("div")(_ref => {
  let {
    themeMode
  } = _ref;
  return `
    background-color: ${_menuTheme.menuTheme.backgroundColor.rest(themeMode)};
    position: sticky;
    top: 0px;
    padding: 0px ${_designTokens.space.space30} ${_designTokens.space.space20};   
`;
});
const MenuHeader = /*#__PURE__*/(0, _react.forwardRef)((_ref2, ref) => {
  let {
    children,
    clientId
  } = _ref2;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  return /*#__PURE__*/_react.default.createElement(MenuHeaderStyled, {
    "data-client-id": clientId,
    themeMode: themeMode,
    ref: ref
  }, children);
});
exports.MenuHeader = MenuHeader;
MenuHeader.displayName = "MenuHeader";
//# sourceMappingURL=MenuHeader.js.map